import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import styled from "styled-components";
import{ convertStringToElements } from "@vds/html-parsers";

import { setA11yContent } from "../NavigationHelper/actions";
import { checkNestedObject } from "utils/checkNestedObject";
// import { media } from "utils/style";

import Header from "common-components/Header";
import StyledLink from "common-components/StyledLink";
import Container from "common-components/Container";

import FetchPageContent from "../../../hoc/FetchPageContent";

class AccountDisconnected extends Component {
  componentDidMount() {
    if (checkNestedObject(this.props.pageContent, "sc_pagetitle")) {
      this.props.setA11yContent("account disconnected", this.props.pageContent.sc_pagetitle);
    }
  }

  render() {
    const { richText, buttons } = this.props.pageContent;

    return (
      <Div>
        {richText && richText.length && (
          <>
            <Header>{convertStringToElements(richText[0].title)}</Header>
            <ContentDiv>{convertStringToElements(richText[0].description)}</ContentDiv>
          </>
        )}
        <StyledLink
          background={buttons[0].type}
          style={{ marginTop: "45px" }}
          linkType="anchor"
          href={buttons[0].link}
        >
          {buttons[0].text}
        </StyledLink>
      </Div>
    );
  }
}

const mapStateToProps = ({ pageContent: { accountdisconnectedcustomer: pageContent } }) => ({
  pageContent
});

export default compose(
  connect(
    mapStateToProps,
    { setA11yContent }
  ),
  FetchPageContent
)(AccountDisconnected);

const Div = styled(Container)`
  margin: 0;
  padding: 80px 16px;
  max-width: 656px;
`;

const ContentDiv = styled.div`
  p {
    margin: 8px 0;
  }
`;
